import {ROUTE_CATEGORY_PAGE_API} from './../../config/apiPoints';
import {fetchHelper} from './../../../utils/fetchHelper';
export const prepareRouteCategoryPageRequest =(params)=>{
    const url = `${__ENV_CONFIG__.__PAGEROVER__}${ROUTE_CATEGORY_PAGE_API}?slug=${params.slug}-buses-from-${params.src}-to-${params.dest}`
  
    return url;
  }
  export async function getRouteCategoryPageData(params){
      const url = prepareRouteCategoryPageRequest(params);
     
      let data={}
      try{
      data = await fetchHelper({
       name: 'route category page',
       type: 'GET',
       url: url,
     });
    }catch(err){
        data={status:false,error:true}
    }
    return data;
    
  }
  
